// Setup function for Vue 3 modal functionality
export const setupModal = app => {
  // Create a reactive reference to store the modal instance
  let modalInstance = null

  // Check if $modal is already defined to prevent redefinition errors
  if (!Object.hasOwnProperty.call(app.config.globalProperties, '$modal')) {
    // Define a getter/setter for $modal on globalProperties
    Object.defineProperty(app.config.globalProperties, '$modal', {
      get() {
        return modalInstance
      },
      set(newInstance) {
        modalInstance = newInstance
      },
    })
  }
}

export default {
  install: app => {
    setupModal(app)
  },
}
